import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";


export const useCaseStudyDelete = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const res = await api.delete(`/case-study/delete/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["viewCaseStudy"] });
      queryClient.invalidateQueries({ queryKey: ["viewSubscription"] });
    },
    onError: (error) => {
      console.log("DELETE ERROR:", error.response || error);
    },
  });
};
